<app-card-medium title="{{ 'Notifications' | translate }}" [hasAction]="true">
    <div *ngIf="canAccessGeneralNotification">
        <div
            style="display: flex; justify-content: space-between; padding-bottom: 1em; padding-left: 1em; padding-right: 1em;">
            <div style="display: flex; justify-content: space-evenly;">
                <button class="btn btn-sm" style="margin: 0px 1em;"
                    [ngClass]="{ 'btn-primary': isForYouSelected, 'btn-secondary': !isForYouSelected }"
                    (click)="this.isForYouSelected = true">{{'For You' | translate}}</button>
                <button class="btn btn-sm" style="margin: 0px 1em;"
                    [ngClass]="{ 'btn-primary': !isForYouSelected, 'btn-secondary': isForYouSelected }"
                    (click)="this.isForYouSelected = false">{{'General' | translate}}</button>
            </div>
            <div style="display: flex; justify-content: space-evenly;">
                <div *ngIf="isForYouSelected&&notifications&&notifications.length>0"
                    style="display: flex; justify-content: flex-end;">
                    <button class="btn btn-sm btn-primary" style="margin: 0px 1em;" (click)="onClickReadAll()">{{'Mark all as Read' | translate}}</button>
                </div>
                <div *ngIf="!isForYouSelected" style="display: flex; justify-content: flex-end;">
                    <button class="btn btn-sm btn-primary" style="margin: 0px 1em;"
                        (click)="onClickSettings()">{{'Settings' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="content scrollable">
        <div *ngIf="isForYouSelected">
            <div *ngIf="!notifications" style="display: flex; justify-content: center; padding: 1em;">{{'Loading...' | translate}}
            </div>
            <div *ngIf="notifications">
                <div *ngIf="notifications.length==0" style="display: flex; justify-content: center; padding: 1em;">{{'No notifications.' | translate}}</div>
                <div *ngFor="let notification of notifications; trackById">
                    <a (click)="onClickNotification(notification)">
                        <div class="user-card inner-shadow"
                            [ngStyle]="{'border': notification.has_read ? 'solid 1px black' : 'solid 1px #1B9BBB', 'opacity': notification.has_read ? 0.5 : 1}">
                            <div class="details">
                                <div class="title text-left">{{ notification.text | translate: { "assigner:name": getAssigner(notification.title), "annotation:name": getAnnotation(notification.title)} }}</div>
                                <div class="detail">
                                    <div class="desc">{{notification.created_at | date:'short'}}</div>
                                </div>
                            </div>
                            <div class="avatar" style="background-image: url('{{notification.url}}');">
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div *ngIf="!isForYouSelected">
            <div *ngIf="!auditTrails" style="display: flex; justify-content: center; padding: 1em;">{{'Loading...' |
                translate}}
            </div>
            <div *ngIf="auditTrails">
                <div *ngIf="auditTrails.length==0" style="display: flex; justify-content: center; padding: 1em;">{{'No notifications. Check settings for more info.' | translate}}</div>
                <div *ngFor="let auditTrail of auditTrails; trackById">
                    <a (click)="onClickAuditTrail(auditTrail)">
                        <div class="user-card inner-shadow">
                            <div class="details">
                                <div class="title text-left">{{auditTrail?.user?.fullname}} {{
                                    getTitleAction(auditTrail?.title) | translate | lowercase }} {{getTitleItem(auditTrail?.title)}}
                                    {{auditTrail?.location?.name}}
                                </div>
                                <div class="detail">
                                    <div class="desc">{{auditTrail.created_at | date:'short'}}</div>
                                </div>
                            </div>
                            <div class="avatar" style="background-image: url('{{auditTrail.url}}');">
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</app-card-medium>